import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPencil3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"pencil-3, edit, write, prompt"} maskId="square-filled-radius-0-stroke-1-IconPencil3"><path fillRule="evenodd" clipRule="evenodd" d="M15.1455 3.14608C16.7214 1.57045 19.2766 1.57045 20.8525 3.14608C22.4284 4.72196 22.4283 7.27711 20.8525 8.85311L9.23926 20.4664L2.39062 21.608L3.53223 14.7594L15.1455 3.14608ZM13.793 9.50057L14.5 10.2076L18.707 6.00057L18 5.29354L13.793 9.50057Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPencil3;
